import { ROUTE_ACCESS, ROUTE_GROUP, ROUTE_REGISTRY } from '@/constants/routes'

/**
 * Normalizes a URL path by removing trailing slashes
 * and adding exactly one trailing slash.
 *
 * The root path and empty values are normalized to '/'.
 */
export const normalizePath = path => {
  if (!path || path === '/') return '/'

  const trimmedPath = path.replace(/\/+$/, '')
  return `${trimmedPath || '/'}/`
}

const PUBLIC_ROUTES = new Set(
  ROUTE_REGISTRY.filter(r => r.access === ROUTE_ACCESS.PUBLIC).map(r => normalizePath(r.path))
)

const AUTH_ROUTES = new Set(
  ROUTE_REGISTRY.filter(r => r.group === ROUTE_GROUP.LOGIN).map(r => normalizePath(r.path))
)

const EMAIL_VERIFICATION_ROUTES = new Set(
  ROUTE_REGISTRY.filter(r => r.group === ROUTE_GROUP.EMAIL).map(r => normalizePath(r.path))
)

/** Routes reachable without an authenticated session. */
export const isPublicRoute = pathname => PUBLIC_ROUTES.has(normalizePath(pathname))

export const getPathFromTarget = target => target?.split('?')[0] ?? ''

export const isAuthRoute = pathname => AUTH_ROUTES.has(normalizePath(pathname))

export const isEmailVerificationRoute = pathname =>
  EMAIL_VERIFICATION_ROUTES.has(normalizePath(pathname))

export const shouldSaveAuthRedirect = pathname => !isPublicRoute(pathname)
